// extracted by mini-css-extract-plugin
export default {"section":"PrintStyles_section__6GuAy","input":"PrintStyles_input__DYoyK"};